import { useStripe, useElements } from '@stripe/react-stripe-js'
import useAddPaymentCardDialogViewModel from './AddPaymentCardDialogViewModel'

import CircleSpinner from '@components/shared/CircleSpinner'
import CustomModal from '@components/shared/CustomModal/CustomModal'
import AddPaymentCardDialogStatus from './widgets/AddPaymentCardDialogStatus'
import AddPaymentCardDialogError from './widgets/AddPaymentCardDialogError'
import AddPaymentCardDialogForm from '@components/shared/Dialogs/AddPaymentCardDialog/widgets/AddPaymentCardDialogForm'
import cn from 'clsx'
// import { PricingInfo } from '@components/settings/PricingInfo'

/*
Sample Stripe Cards:
Visa ... 4242424242424242 ... Any 3 digits ... Any future date
Visa (debit) ... 4000056655665556 ... Any 3 digits ... Any future date
Mastercard ... 5555555555554444 ... Any 3 digits ... Any future date
Mastercard (2-series) ... 2223003122003222 ... Any 3 digits ... Any future date
Mastercard (debit) ... 5200828282828210 ... Any 3 digits ... Any future date
Mastercard (prepaid) ... 5105105105105100 ... Any 3 digits ... Any future date
American Express ... 378282246310005 ... Any 4 digits ... Any future date
American Express ... 371449635398431 ... Any 4 digits ... Any future date
*/

export const AddPaymentCardDialog = () => {
    
    const stripe = useStripe()
    const elements = useElements()
    
    const vm = useAddPaymentCardDialogViewModel(stripe, elements)
    
    return (
        
        <CustomModal
            open={vm.open}
            modalHandler={() => vm.handleModal()}
            center
            styles={{ modal: { maxWidth: '500px' } }}>
            
            <div className="modal-body">
                
                <div className="mb-8">
                    <div className="text-center">
                        <h4 className="modal-title">
                            Add Payment Method
                        </h4>
                    </div>
                </div>
                
                <div className={cn('p-4 flex flex-col items-center', {
                    'hidden': stripe && elements && !vm.loading,
                })}>
                    <CircleSpinner/>
                </div>
                
                {vm.error?.length ? (
                    <AddPaymentCardDialogError
                        error={vm.error}
                        setError={vm.setError}
                        handleModal={vm.handleModal}/>
                ) : vm.message?.length ? (
                    <AddPaymentCardDialogStatus
                        message={vm.message}
                        handleModal={vm.handleModal}/>
                ) : (
                    <AddPaymentCardDialogForm
                        stripe={stripe}
                        elements={elements}
                        loading={vm.loading}
                        handleSubmit={vm.handleSubmit}
                        handleModal={vm.handleModal} />
                )}
            
            </div>
        
        </CustomModal>
        
    )
    
}

export default AddPaymentCardDialog
